import { createEvent } from "effector";

export const resetAll = createEvent();
